import Link from "next/link";
import { Gamja_Flower } from "next/font/google";
import { ArrowRight } from "lucide-react";
import { GamjaHomeHero } from "@workspace/ui/components/gamja-home";
import StudyStartButton from "@/components/home/StudyStartButton";
import ChuseokHeroBackdrop from "@/components/home/ChuseokHeroBackdrop";
import SeasonalImage from "@/components/SeasonalImage";
import { ACTIVE_SEASON_SKIN } from "@/lib/season-skin";

const DESCRIPTION = "이론부터 기출·모의고사까지. 오늘 할 일을 감자가 챙겨줄게요.";

const gamja = Gamja_Flower({
  weight: "400",
  subsets: ["latin"],
  display: "swap",
  fallback: ["serif"],
});

/**
 * 홈 대시보드 중앙 — 환영 히어로 (JCG-2110, 신규 IA).
 *
 * 감자 집사 마스코트 + 두 CTA(공부 시작 / 내 진도). 정적 콘텐츠라 서버 컴포넌트로 두되,
 * 셸·클래식 양쪽에서 동일하게 본문 상단에 놓인다.
 */
export default function HomeHero() {
  const isChuseok = ACTIVE_SEASON_SKIN === "chuseok";

  return (
    <GamjaHomeHero
      badge="정보처리기사 실기"
      title={
        <>
          정처기 합격, <span className="text-amber-500">감자랑</span> 같이 가요
        </>
      }
      description={
        isChuseok ? (
          <>
            {/* 해 질 녘 하늘은 기본 배경보다 어두워 muted 글씨가 AA 에 못 미친다 */}
            <span className="season:text-stone-600 season:dark:text-stone-300">
              {DESCRIPTION}
            </span>
            <span
              className={`${gamja.className} mt-2 hidden text-lg text-indigo-700 season:block dark:text-amber-200`}
            >
              더도 말고 덜도 말고, 합격만 같아라 🌕
            </span>
          </>
        ) : (
          DESCRIPTION
        )
      }
      primaryAction={<StudyStartButton />}
      secondaryAction={
        <Link
          href="/my"
          className="inline-flex items-center gap-1.5 rounded-full border border-border bg-card px-5 py-2.5 text-sm font-semibold text-foreground transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
        >
          내 진도 보기 <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      }
      headingClassName={gamja.className}
      backdrop={isChuseok ? <ChuseokHeroBackdrop /> : undefined}
      mascot={
        <SeasonalImage
          src="/main/3d_no-bg_butler_half-clothes_gamja.webp"
          alt="공부를 도와주는 감자 집사"
          width={150}
          height={150}
          priority
          className="hidden h-[130px] w-[130px] shrink-0 object-contain drop-shadow-xl sm:block sm:h-[150px] sm:w-[150px]"
        />
      }
    />
  );
}
